import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import style from './style.scss';

export const ButtonLink = ({ className, children, onClick, isDisabled, ...rest }) => (
  <div
    className={cn(style.button, className, isDisabled && style.disabled)}
    onClick={!isDisabled ? onClick : () => {}}
    {...rest}
  >
    {children}
  </div>
);

ButtonLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
};

ButtonLink.defaultProps = {
  className: '',
  onClick: () => {},
  children: null,
  isDisabled: false,
};

export default ButtonLink;



// WEBPACK FOOTER //
// ./src/components/Button/ButtonLink.js